import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

const CARDS = [
  { bg: "bg-cyan", text: "text-ink", sub: "text-ink/60", border: "border-ink/15" },
  { bg: "bg-magenta", text: "text-white", sub: "text-white/75", border: "border-white/25" },
  { bg: "bg-violet", text: "text-white", sub: "text-white/75", border: "border-white/25" },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="bg-white">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="09" label="Opinie" color="bg-cyan" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Co mówią uczestnicy szkoleń Anny
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => {
          const isPlaceholder = t.quote.startsWith("[");
          return (
            <Reveal key={t.quote} delay={i * 0.1} className="h-full">
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className={`flex h-full flex-col rounded-3xl border-2 p-7 shadow-hard ${
                  isPlaceholder ? "border-dashed border-ink/40 bg-white/60" : `border-ink ${CARDS[i % 3].bg}`
                } ${i === 1 ? "md:rotate-1" : i === 2 ? "md:-rotate-1" : ""}`}
              >
                <Quote
                  className={`h-8 w-8 ${isPlaceholder ? "text-ink/25" : CARDS[i % 3].text}`}
                  aria-hidden="true"
                />
                <blockquote
                  className={`mt-4 flex-1 text-base leading-relaxed ${
                    isPlaceholder ? "font-semibold text-ink/35" : `font-semibold ${CARDS[i % 3].text}`
                  }`}
                >
                  {t.quote}
                </blockquote>
                {(t.name || t.role) && (
                  <figcaption className={`mt-5 border-t-2 pt-4 ${isPlaceholder ? "border-ink/15" : CARDS[i % 3].border}`}>
                    {t.name && <p className={`text-sm font-extrabold ${CARDS[i % 3].text}`}>{t.name}</p>}
                    {t.role && <p className={`text-xs font-semibold ${CARDS[i % 3].sub}`}>{t.role}</p>}
                  </figcaption>
                )}
              </figure>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
